import React, { useState, useEffect } from 'react';
import { fetchAllContacts } from '../../../services/operations/ContactFormAPI'; // Adjust the path if necessary
import { toast } from 'react-toastify';

const ContactList = () => {
    const [contacts, setContacts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadContacts = async () => {
            try {
                const contactsData = await fetchAllContacts();
                
                // If the returned data is empty, handle it
                if (contactsData.length === 0) {
                    setError('No contacts found.');
                } else {
                    setContacts(contactsData); // Set contacts if available
                }
            } catch (error) {
                setError('Failed to load contacts.');
                toast.error('Failed to load contacts');
            } finally {
                setLoading(false);
            }
        };

        loadContacts();
    }, []);

    // Conditional rendering based on the loading, error, and contacts state
    if (loading) return <p>Loading...</p>;
    if (error) return <p>{error}</p>;

    return (
        <div className="p-6">
            <h1 className="text-3xl font-bold mb-6 text-[#D4B328] font-roboto">Contact List</h1>
            {contacts.length > 0 ? (
                <div className="overflow-x-auto">
                    <table className="min-w-full border-collapse bg-white shadow-lg rounded-lg overflow-hidden">
                        <thead className="bg-gradient-to-r from-blue-500 to-[#26A69A] text-white">
                            <tr>
                                <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider">Name</th>
                                <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider">Address</th>
                                <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider">Mobile</th>
                                <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider">Email</th>
                                <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider">Message</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-richblack-200">
                            {contacts.map((contact) => (
                                <tr key={contact._id} className="hover:bg-richblack-100 transition duration-200 ease-in-out">
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-richblack-700">{contact.name}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-richblack-700">{contact.address}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-richblack-700">{contact.mobile}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-richblack-700">{contact.email}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-richblack-700">{contact.message}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <p className="text-richblack-500 text-sm mt-4 font-roboto">No contacts available.</p>
            )}
        </div>
    );
};

export default ContactList;
